import styled from '@emotion/styled';

export const NotificationWrapper = styled.div<{breakLine: boolean}>`
    display: flex;
    align-items: baseline;
    white-space: ${props => props.breakLine ? 'pre-line' : undefined}
`;

export const NotificationText = styled.div`
    font-family: 'GreycliffCF-Regular';
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.10000000149011612px;
    color: #000000;
`;

export const NotificationLink = styled.a`
    font-family: GreycliffCF, serif;
    font-size: 13px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.10000000149011612px;
    color: #000000;
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
`;
